module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "childComments"
  }, _vm._l((_vm.sortedComments), function(comment, index) {
    return _c('comment', {
      key: index,
      attrs: {
        "comment": comment,
        "childComments": _vm.childComments,
        "postId": _vm.postId
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69aacbe4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ChildComments.vue
// module id = 790
// module chunks = 1